import { useAppSelector } from "./redux_hooks";

import { Settings } from "settings";
import { SidebarPanelType } from "shared/types";
import { classroomSelectors, localSelectors } from "store";

export const useSidebarAdjustment = (padding: number = 0) => {
  const currentSidebarPanel = useAppSelector(localSelectors.selectSidebarPanel());
  const isSidebarOpen = currentSidebarPanel !== SidebarPanelType.None;
  const isPresentationView = useAppSelector(classroomSelectors.selectIsPresentationView());

  let visibleSidebarWidth;
  if (isPresentationView) {
    visibleSidebarWidth = 0;
  } else if (isSidebarOpen) {
    visibleSidebarWidth =
      Settings.SIDEBAR_CONTENT_WIDTH + Settings.SIDEBAR_CONTROLS_WIDTH + padding;
  } else {
    visibleSidebarWidth = Settings.SIDEBAR_CONTROLS_WIDTH + padding;
  }

  return `calc(100vw - ${visibleSidebarWidth}px)`;
};
